app.service('deliveryPoints', function(console, orderConfig, modal, deliveryPointModal, deliveryPointAutocomplete) {
	var config, url, autocompleteInput, savedParams = {};
	var $self, $list, $type, $form, $points, $lastPoint, $more, $lastPointBox, initCallback;
	let selectedTypes = [];
	var isLoading = false;
	let selectedAutocompletePlace = {};

	function setElements(){
		$self = $('#delivery-points');
		$form = $('#frontForm');
		$list = $('.delivery-list', $self);
		$type = $('.js-parcel-type', $self);
		$lastPointBox = $('#last-saved-point', $self);
		autocompleteInput = $('.place-search', $self)[0];
	}
	function setEvents(){
		$self.on('click', '.js-delivery-point', function(){
			var $this = $(this);
			if ($points && $points.length) {
				if ($lastPoint && $lastPoint.length) {
					$lastPoint.removeClass('selected');
				}
				$points.removeClass('selected');
			}
			$this.addClass('selected');
			selectPoint({
				point: $this.data('point'),
				city: $this.data('city'),
				type: $this.data('type'),
				courier: $this.data('courier')
			});
		}).on('click', '.js-toggle-openings-hours', function(event){
			$(this).closest('.js-delivery-point').toggleClass('show-opening-hours');
			event.preventDefault();
			event.stopPropagation();
		}).on('click', '.js-change-point', function(event){
			var data = {
				longitude: $(this).data('longitude'),
				latitude: $(this).data('latitude')
			};
			$self.removeClass('show-last-selected');
			let $point = $(this).closest('js-delivery-point');
			$point.removeClass('saved').addClass('selected');
			load(data, { select: $point.data('point') });
			event.preventDefault();
			event.stopPropagation();
		}).on('click', '.js-more-delivery-points', function () {
			filter({count: savedParams.count + 10});
		}).on('click', '.js-parcel-type', function(){
			setSelectedParcelType($(this).data('type'));
			filter({types: selectedTypes});
		}).on('click', '.js-show-map', function () {
			selectedAutocompletePlace.input = autocompleteInput.value;
			deliveryPointModal.open(selectedAutocompletePlace, function(params) {
				var $box = $('#last-saved-point');
				$box.html(params.html);
				$lastPoint = $box.find('.delivery-point');
				$lastPoint.addClass('visible selected saved');
				$self.removeClass('show-list show-more').addClass('show-last-selected has-last-selected');
				selectPoint({
					point: $lastPoint.data('point'),
					city: $lastPoint.data('city'),
					type: $lastPoint.data('type'),
					courier: $lastPoint.data('courier')
				});
			});
		}).on('click', '.js-delivery-points-search', function(){
			$self.addClass('search-geolocation');
			navigator.geolocation.getCurrentPosition(function (position) {
				$self.removeClass('search-geolocation');
				load({
					latitude:position.coords.latitude,
					longitude: position.coords.longitude
				});
			}, function(error){
				$self.removeClass('search-geolocation');
				modal.alert(error.message);
			});
		});
		setAutocomplete();
	}

	function setSelectedParcelType(type) {
		const $selectAll = $('.js-parcel-type[data-type=0]', $self);
		const idx = $.inArray(type, selectedTypes);
		if (type == '0') {
			selectedTypes = [];
		} else {
			if (idx == -1) {
				selectedTypes.push(type);
			} else {
				selectedTypes.splice(idx, 1);
			}
		}
		$type.removeClass('selected');
		if (!selectedTypes.length) {
			$selectAll.addClass('selected');
		} else {
			$selectAll.removeClass('selected');
			selectedTypes.forEach(function (t) {
				$type.filter('[data-type="' + t + '"]').addClass('selected');
			});
		}
	}

	function setAutocomplete() {
		deliveryPointAutocomplete.setAutocomplete(autocompleteInput, function(location) {
			if (location) {
				setSelectedAutocompletePoint(location);
			}
		}, function () {
			$self.addClass('empty-location');
			$('.empty-location-message strong', $self).text($.trim(autocompleteInput.value))
		});
	}

	function setSelectedAutocompletePoint(location) {
		load({
			latitude: location.lat(),
			longitude: location.lng()
		});
	}


	function selectPoint(data){
		$('#dhl-parcel-point-code-error, #post-office-code-error, #inpost-point-error').remove();
		if(config.deliveryType == 'inpost'){
			$('#inpost-point').val(data.point);
			$form.validate().element('#inpost-point');
		} else {
			if(data.courier == 'POST_OFFICE_POINT'){
				$('#dhl-parcel-point-code').val('').ignore(true);
				$('#post-office-code').val(data.point).ignore(false);
			}else{
				$('#dhl-parcel-point-code').val(data.point).ignore(false);
				$('#post-office-code').val('').ignore(true);
			}
			$form.validate().element('#dhl-parcel-point-code');
			$form.validate().element('#post-office-code');
		}
	}
	function loadLast(url){
		$.ajax({
			url: url,
			data: {
				orderNumber: config.orderNumber
			},
			success: function(html) {
				$self.addClass('init');
				$('#last-saved-point').html(html);
				$lastPoint = $lastPointBox.find('.js-delivery-point');
				if ($lastPoint.length) {
					$('#delivery-point-localization').val('last');
					$('#delivery-point-localization-error').remove();
					$form.validate().element('#delivery-point-localization');
					$lastPoint.addClass('visible');
					$self.addClass('has-last-selected show-last-selected');
					selectPoint({
						point: $lastPoint.data('point'),
						city: $lastPoint.data('city'),
						type: $lastPoint.data('type'),
						courier: $lastPoint.data('courier')
					});
				}
				if(initCallback){
					initCallback();
				}
			},
			error: function(){
				$self.addClass('init');
				modal.alert('Błąd pobierania ostatnio wybranego punktu odbioru');
			}
		});
	}

	function init(callback){
		initCallback = callback;
		config = orderConfig.getData();
		setElements();
		setEvents();
		if(config.deliveryType == 'inpost'){
			url = '/parcelMachines-list.ltr';
			loadLast('/order-last-selected-parcel-machine.ltr');
		}else{
			url = '/order-pickup-points.ltr';
			loadLast('/order-last-selected-pickup-point.ltr');
		}
	}
	function filter(params) {
		savedParams = $.extend(savedParams, params);
		$points.removeClass('visible');
		var $filtered = $points;
		if (savedParams.types && savedParams.types.length > 0) {						// wyfiltrowanie tylko punktów z konkretnego typu
			$filtered = $points.filter(function(){
				return savedParams.types.includes($(this).data('type'));
			});
		}
		$self.removeClass('empty-search empty-filter');
		if ($filtered.length == 0) {
			if (savedParams.types && savedParams.types.length != 0 ) {
				$self.addClass('empty-filter');
			} else {
				$self.addClass('empty-search');
			}
		}
		if ($filtered.length > savedParams.count) {
			$self.addClass('show-more');
		} else {
			$self.removeClass('show-more');
		}
		var $visible = $filtered.slice(0, savedParams.count);
		$($visible).addClass('visible');
	}

	function load(ajaxParams){
		$self.addClass('loading-list').removeClass('empty-location');
		isLoading = true;
		$('#delivery-point-localization').val(ajaxParams);
		$('#delivery-point-localization-error').remove();
		$form.validate().element('#delivery-point-localization');
		if (ajaxParams.latitude && ajaxParams.longitude) {
			selectedAutocompletePlace.lat = ajaxParams.latitude;
			selectedAutocompletePlace.lng = ajaxParams.longitude;
		}
		$.ajax({
			url: url,
			data:ajaxParams,
			success:function(html){
				$list.html(html);
				$points = $('.js-delivery-point', $list);
				$more = $('.js-more-delivery-points', $list);
				$self.addClass('init show-list').removeClass('loading-list');
				if ($lastPoint && $lastPoint.length) {
					$lastPoint.removeClass('saved');
					$points.filter('[data-point="' + $lastPoint.data('point') + '"]').remove();
					$points = $('.js-delivery-point', $list);
				}
				setVisibleTypes();
				filter({ types: selectedTypes, count: 3 });
				isLoading = false;
			},
			error:function(){
				$self.removeClass('loading-list');
				modal.alert('Błąd ładowania punktów odbioru. Spróbuj ponownie');
				isLoading = false;
			}
		});
	}
	function setVisibleTypes() {
		$type.not('[data-type="0"]').addClass('hidden');
		$points.each(function () {
			var type = $(this).data('type');
			$type.filter('[data-type="' + type + '"]').removeClass('hidden');
		});
		$type.filter('.selected.hidden').each(function () {
			setSelectedParcelType('0');
		});
	}
	function setZipCode(value) {
		var data = {};
		if (!isLoading && /\d{2}\-\d{3}/.test(value) && !($points && $points.length)) {
			if(config.deliveryType == 'inpost'){
				data.postcode = value;
			}else{
				data.zipCode = value;
			}
			load(data);
		}
	}

	return {
		init, setZipCode
	};
});